export enum EChartProvider {
  ORIGINAL = 'ORIGINAL',
  TRADING_VIEW = 'TRADING_VIEW'
}
